import { PocButton } from 'commons/components/components-wrapper/poc-button.component';
import { PocIcon } from 'commons/components/components-wrapper/poc-icon.component';
import { useTranslation } from 'core/i18n/i18n';
import { useCustomAlarmsList } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/hooks/use-custom-alarms-list/use-custom-alarms-list.hook';
import { useDefaultConfigCustomAlarmsList } from './hooks/use-default-config-custom-alarms-list/use-default-config-custom-alarms-list.hook';
import {
    CustomAlarmsContent,
    CustomNotificationsActionsRow,
    CustomNotificationsTableContainer,
} from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/settings-devices-custom-alarm-list.style';
import { CustomTableComponent } from 'commons/components';
import { CustomAlarmListItem } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/settings-devices-custom-alarm-list.model';
import { usePreserveSelectedHeaderCheckProps } from 'commons/components/table/hooks';
import { CustomAlarmRowOptionsComponent } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/components/custom-alarm-row-options/custom-alarm-row-options.component';
import { CustomAlarmEditCommandComponent } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/components/commands/custom-alarm-edit-command.component';
import { SettingsTableHeaderOptionsComponent } from 'modules/settings/components/settings-table-header-options/settings-table-header-options.component';
import { useCustomAlarmsNavigation } from 'modules/settings/pods/settings-devices/settings-devices-configuration/hooks/use-custom-alarms-navigation/use-custom-alarms-navigation.hook';

export const SettingsDevicesCustomAlarmListContainer: React.FC = () => {
    const { t } = useTranslation();
    const {
        customAlarms,
        isLoading,
        selectedRows,
        handleOnSelectRow,
        setSelectedRows,
        handleOnlyActiveChange,
        onlyActive,
    } = useCustomAlarmsList();
    const { navigateToCreate, navigateToEdit } = useCustomAlarmsNavigation();
    const { getDefaultConfig } = useDefaultConfigCustomAlarmsList();

    const { selectedRowIds, headerCheckboxProps } = usePreserveSelectedHeaderCheckProps({
        selectedRows,
        data: customAlarms,
        setSelectedRows,
    });

    const getRowOptions = (customAlarm: CustomAlarmListItem) => [
        <CustomAlarmEditCommandComponent
            key={`custom-alarm-edit-command-${customAlarm.id}`}
            customAlarmId={customAlarm.id}
        />,
        <CustomAlarmRowOptionsComponent key={`custom-alarm-row-option-${customAlarm.id}`} customAlarm={customAlarm} />,
    ];

    return (
        <CustomAlarmsContent>
            <CustomNotificationsActionsRow>
                <PocButton variant="secondary" onClick={navigateToCreate}>
                    <PocIcon slot="prefix" name="circle_add" />
                    {t('settings.devices.custom-alarms.list.actions.add')}
                </PocButton>
            </CustomNotificationsActionsRow>

            <CustomNotificationsTableContainer>
                <CustomTableComponent<CustomAlarmListItem>
                    headerTitle={t('settings.devices.custom-alarms.list.title')}
                    loading={isLoading}
                    totalElements={customAlarms.length}
                    tableData={customAlarms}
                    selectedRowIds={selectedRowIds}
                    headerCheckboxProps={headerCheckboxProps}
                    config={getDefaultConfig()}
                    horizontalScroll
                    rowOptions={getRowOptions}
                    onClickRow={(id) => navigateToEdit(id)}
                    selectedRows={selectedRows}
                    onSelectRow={(id, event) => handleOnSelectRow(id, event.detail)}
                    emptyMessage={t('settings.devices.custom-alarms.list.empty')}
                    optionComponents={
                        <SettingsTableHeaderOptionsComponent
                            onShowOnlyActiveChange={handleOnlyActiveChange}
                            showOnlyActive={onlyActive}
                            text={t('settings.devices.custom-alarms.list.actions.show-inactive')}
                        />
                    }
                />
            </CustomNotificationsTableContainer>
        </CustomAlarmsContent>
    );
};
